cv.renderProgressSteps = function(current_step, total_steps, context){
  if(context.$('.setup-progress').html() == ''){
    for(var i=1; i<=total_steps; i++){
      if(current_step == i){
        context.$('.setup-progress').append('<div class="circle active"></div>');
      }else if(current_step > i){
        context.$('.setup-progress').append('<div class="circle completed"></div>');
      }else{
        context.$('.setup-progress').append('<div class="circle"></div>');
      }
    }
  }else{
    for(var i=1; i<=total_steps; i++){
      if(current_step == i){
        context.$('.setup-progress .circle:eq(' + +(i - 1) + ')').removeClass('completed');
        context.$('.setup-progress .circle:eq(' + +(i - 1) + ')').addClass('active');
      }else if(current_step > i){
        context.$('.setup-progress .circle:eq(' + +(i - 1) + ')').removeClass('active');
        context.$('.setup-progress .circle:eq(' + +(i - 1) + ')').addClass('completed');
      }else{
        context.$('.setup-progress .circle:eq(' + +(i - 1) + ')').removeClass('active completed');
      }
    }
  }
};